/* eslint-disable */
function throttle(fn, wait) {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    if (!timer) {
      timer = setTimeout(() => {
        timer = null;
        fn.apply(context, args);
      }, wait);
    }
  };
}

function debounce(fn, delay = 0) {
  let timer = null;
  return function () {
    const _this = this;
    const args = arguments;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(_this, args);
    }, delay);
  };
}

function setPostLimit() {
  const elementCollection = document.getElementsByClassName("post-feed-limit");
  const removePoint = document.documentElement.clientWidth > 853 ? 2 : 1;
  for (let i = 0; i < elementCollection.length; i++) {
    const element = elementCollection[i];
    const articleCollection = element.getElementsByTagName("article");
    for (let j = 0; j < articleCollection.length; j++) {
      if (j <= removePoint) {
        articleCollection[j].setAttribute("data-need-delete", "false");
      } else {
        articleCollection[j].setAttribute("data-need-delete", "true");
      }
    }
  }
  $("article[data-need-delete='true']").css({ display: "none" });
  $("article[data-need-delete='false']").css({ display: "block" });
}

$(document).ready(setPostLimit);

window.addEventListener("resize", throttle(setPostLimit, 200));
window.addEventListener(
  "message",
  function (e) {
    if (e.data.size) {
      let iframeNode = document.getElementById("footer-iframe");
      iframeNode.setAttribute("height", e.data.size.height + 10);
    }
  },
  false
);
